import { object, string } from 'yup';

import i18n from '@app/i18n/config';

import { websiteSchema } from '@entities/index';

import { emailRegEx, phoneRegEx } from '@shared/index';

export const contactsSchema = object({
  email: string()
    .required(i18n.t('COMMON:errors.required'))
    .matches(emailRegEx, i18n.t('COMMON:errors.incorrectEmail')),
  phone: string()
    .required(i18n.t('COMMON:errors.required'))
    .matches(phoneRegEx, i18n.t('COMMON:errors.incorrectPhoneNumber')),
}).concat(websiteSchema);
